import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const StudyMaterialFilled = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Path
      d="m21.08 14.82-3.34-9.76c-.18-.53-.75-.81-1.28-.63l-3.61 1.24V4.64c0-.75-.61-1.36-1.36-1.36H8.06c-.75 0-1.36.61-1.36 1.36v1.38c-.1-.02-.21-.04-.32-.04H3.66c-.74 0-1.34.6-1.34 1.34v8.55h4.37v.97H2.32v1.65c0 .74.6 1.34 1.34 1.34h2.71c.32 0 .6-.11.83-.3.23.18.52.3.84.3h3.43c.75 0 1.36-.61 1.36-1.36V9.76l2.4 7.02 5.72-1.94s.07 0 .11-.01l.02-.01Zm-9.79 3.46H8.26V4.84h3.03v13.44ZM21.95 17.36l-.51-1.48s-.06.04-.1.06l-5.72 1.94.5 1.47c.18.53.75.81 1.28.63l3.91-1.34c.53-.18.81-.75.63-1.28h.01Z"
      fill={color}
    />
  </Svg>
)

export default StudyMaterialFilled
